import { Navigate, useLocation } from 'react-router-dom';
import { authRoutes, resetPasswordRoute } from '../components/common';
import Cookies from 'js-cookie';
import Context from '../context/Context';
import { useContext } from 'react';

const PublicRoute = ({ children }) => {
  const token = Cookies.get('adminToken');
  const { pathname } = useLocation();
  const { user } = useContext(Context);

  const successPath = user &&  user?.role ? '/dashboard' : '/admin/dashboard'
  if (token) {
    return <Navigate to={successPath} />;
  }
  const isAuthRoute = authRoutes.includes(pathname) || pathname.startsWith(resetPasswordRoute);;
  if (!isAuthRoute) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PublicRoute;

